import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// iOS Viewport Configuration
const metaViewport = document.createElement('meta');
metaViewport.name = 'viewport';
metaViewport.content = 'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover';
document.head.appendChild(metaViewport);

// iOS Theme Color
const metaThemeColor = document.createElement('meta');
metaThemeColor.name = 'theme-color';
metaThemeColor.content = '#007AFF';
document.head.appendChild(metaThemeColor);

// iOS Mobile Web App Capable
const metaAppleMobileWebAppCapable = document.createElement('meta');
metaAppleMobileWebAppCapable.name = 'apple-mobile-web-app-capable';
metaAppleMobileWebAppCapable.content = 'yes';
document.head.appendChild(metaAppleMobileWebAppCapable);

// iOS Status Bar Style
const metaAppleMobileWebAppStatusBarStyle = document.createElement('meta');
metaAppleMobileWebAppStatusBarStyle.name = 'apple-mobile-web-app-status-bar-style';
metaAppleMobileWebAppStatusBarStyle.content = 'black-translucent';
document.head.appendChild(metaAppleMobileWebAppStatusBarStyle);

// iOS Icons
const linkAppleTouchIcon = document.createElement('link');
linkAppleTouchIcon.rel = 'apple-touch-icon';
linkAppleTouchIcon.href = '/adnimi.png';
document.head.appendChild(linkAppleTouchIcon);

// Favicon
const linkFavicon = document.createElement('link');
linkFavicon.rel = 'icon';
linkFavicon.type = 'image/png';
linkFavicon.href = '/adnimi.png';
document.head.appendChild(linkFavicon);

// Render the app
const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        React.createElement(React.StrictMode, null,
            React.createElement(App, null)
        )
    );
} else {
    console.error('Root element not found');
}
